export default {
  toast_messages: {
    google_review_uploaded: 'Your review is successfully verified. You earned {{points}} pts 😉',
  },
};
